/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
import { from } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import {
  CoralResponse,
  CoralInterceptor,
  CoralRequest,
  CoralHandler,
} from '@amzn/ihm-js-coral-client';
import getUser from '../utils/auth/getUser';

// This class is used during client construction, and helps to intercept
// the headers during request handling for the passport external App.
class RequestOptionsInterceptorForPassport extends CoralInterceptor {
  constructor(bindings = {}) {
    super();
    this.bindings = bindings;
  }

  /**
   * @param {CoralRequest} request
   * @param {CoralHandler} next
   * @returns
   */
  // eslint-disable-next-line class-methods-use-this
  intercept(request: CoralRequest, next: CoralHandler) {
    return from(getUser()).pipe(
      switchMap((user) => {
        // Adding required header
        const headers = [
          ['Accept', 'application/json'],
          ['Content-Type', 'application/json'],
        ];

        // If user is found add auth header
        if (user) {
          const { id_token: authToken } = user;
          headers.push(['authorization', authToken]);
        }

        const modifiedRequest = request.clone({
          headers,
          credentials: 'same-origin',
        });
        return next.handle(modifiedRequest);
      }),
      map((response) => {
        return new CoralResponse(response);
      })
    );
  }
}

export default RequestOptionsInterceptorForPassport;
